import "@sum.cumo/vue-datepicker/dist/Datepicker.css";

import Formulate from '@braid/vue-formulate/src/Formulate';
import VueFormulateDatepickerPlugin from 'vue-formulate-datepicker';
import FormulateVSelectPlugin from '@cone2875/vue-formulate-select'

import FaCheckboxComponent from '@/Components/FaCheckboxComponent.vue';
import FaRadioComponent from '@/Components/FaRadioComponent.vue';
import OuterCssClassService from '@/Services/FormulateCssClassService/OuterCssClassService';
import WrapperCssClassService from '@/Services/FormulateCssClassService/WrapperCssClassService';
import HelpCssClassService from '@/Services/FormulateCssClassService/HelpCssClassService';
import LabelCssClassService from '@/Services/FormulateCssClassService/LabelCssClassService';
import InputCssClassService from '@/Services/FormulateCssClassService/InputCssClassService';
import ElementCssClassService from '@/Services/FormulateCssClassService/ElementCssClassService';
import GroupCssClassService from '@/Services/FormulateCssClassService/GroupCssClassService';
import GEFormFields from '@/Types/GEFormFields';
import Vue from 'vue';

Vue.use(Formulate, {
    useInputDecorators: false,
    plugins: [
        VueFormulateDatepickerPlugin,
        FormulateVSelectPlugin,
    ],
    library: {
        checkbox: {
            slotComponents: {
                suffix: FaCheckboxComponent.COMPONENT_NAME,
            },
        },
        radio: {
            slotComponents: {
                suffix: FaRadioComponent.COMPONENT_NAME,
            },
        },
        range: {
            default: 5,
        }
    },
    rules: {
        requiredIfOtherIn({value, getFormValues}: {value: string, getFormValues: () => GEFormFields}, field: string, ...allowed: string[]): boolean {
            if (allowed.includes(getFormValues()[field])) {
                return !!value.trim();
            }

            return true;
        }
    },
    classes: {
        outer: OuterCssClassService.classes.bind(OuterCssClassService),
        wrapper: WrapperCssClassService.classes.bind(WrapperCssClassService),
        help: HelpCssClassService.classes.bind(HelpCssClassService),
        label: LabelCssClassService.classes.bind(LabelCssClassService),
        input: InputCssClassService.classes.bind(InputCssClassService),
        element: ElementCssClassService.classes.bind(ElementCssClassService),
        group: GroupCssClassService.classes.bind(GroupCssClassService),
        error: 'px-2 py-1 mx-2 mt-2 rounded border border-error-darker',
        rangeValue: 'ml-4 text-2xl',
    },
});
